import { t } from 'i18next';
import { ItemType } from '../enums';
import { Core, IItem } from '../slices/inventorySlice';
import store from '../store';
import { ASSET_CONFIG } from '../util/assetConfig';
import { AtLeastTS35 } from '@reduxjs/toolkit/dist/tsHelpers';
import hyNames from '../features/HYAdventure/itemNames.json';
import { avatarPosePath } from '../util/poseAsset';

export function getItemAmount(item: IItem) {
  return item.core?.[Core.AMOUNT] ?? 1;
}

export function getAvatarPose(item: IItem) {
  return avatarPosePath(item.props?.avatar,ASSET_CONFIG.ITEMS[item.iid]?.[0],!!item.props?.hySourceId);
}

export function getItem(idx: number) {
  // Not ideal to do it this way but it does reduce the amount of hooks just for lookup data.
  return store.getState().inventory.items[idx];
}

export function getItemLocation(item: IItem) {
  return item.core?.[Core.LOCATION] ?? -1;
}

export function getItemName(iid: number) {
  if (ASSET_CONFIG.ITEM_NAMES?.[iid]) return ASSET_CONFIG.ITEM_NAMES[iid];
  if ((hyNames as Record<number, string>)[iid]) return (hyNames as Record<number, string>)[iid];
  return t(`item__${iid}--name`);
}

export function getItemPosition(item: IItem) {
  return item.core?.[Core.POSITION] ?? -1;
}

export function getItemPrice(item: IItem) {
  if (item.props?.hySourceId) return item.props.hyPrice ?? 1;
  return ASSET_CONFIG.ITEMS[item.iid]?.[2] ?? 1;
}

export function getItemType(item: IItem): number {
  return item.core?.[Core.TYPE] ?? ItemType.Missing;
}

export const getItemSize = (item: IItem) => {
  if (item.core === undefined) {
    return {
      width: 1,
      height: 1,
    };
  }

  switch (item.core[Core.SIZE]) {
    case 6:
      return {
        width: 2,
        height: 3,
      };
    case 4:
      return {
        width: 2,
        height: 2,
      };
    case 1:
    default:
      return {
        width: 1,
        height: 1,
      };
  }
};

type AtLeast<T, K extends keyof T> = Partial<IItem> & Pick<T, K>;

export function getItemSrc(item: AtLeast<IItem, 'iid'>) {
  if (item.props?.hyIcon) return item.props.hyIcon;
  const src = ASSET_CONFIG.ITEMS[item.iid]?.[0];

  return !src ? 'icons/items/tasks/1.png' : `icons/items/${src}.png`;
}

export function getItemValue(item: IItem) {
  if (item.props?.hySourceId) return item.props.hyValue ?? 1;
  return ASSET_CONFIG.ITEMS[item.iid]?.[1] ?? 0;
}

export function isItemBound(item: IItem) {
  return Number(item.iid) === 159000 || item.core?.[Core.BOUND] === 1;
}

export function isItemType(item: IItem, type: ItemType) {
  return getItemType(item) === type;
}

export function setItemType(item: AtLeast<IItem, 'iid'>, type: ItemType) {
  if (item.core === undefined) {
    item.core = [-1, -1, -1, -1, -1, -1];
    item.core[Core.BOUND] = 1;
  }

  item.core[Core.TYPE] = type;

  return item;
}
